import { Box, Heading, Section } from "@vinomofo/components";
import { ReactNode } from "react";
import { TextAlignT } from "../blocks/accordion/Accordion";

export interface TextBlockProps {
  textAlign?: TextAlignT;
  header?: string;
  bodyText: ReactNode;
}

export const TextBlock = ({
  textAlign = "center",
  header,
  bodyText,
}: TextBlockProps): JSX.Element => {
  return (
    <Box
      textAlign={textAlign?.toLowerCase()}
      paddingLeft={["40px", "80px"]}
      paddingRight={["40px", "80px"]}
      paddingTop={["25px", "30px"]}
      paddingBottom={["25px", "30px"]}
      width="100%"
      backgroundColor="almostWhite"
    >
      {header && (
        <Heading as="h3" fontSize={[2, 2, 3]} color="mofoPrimary">
          {header}
        </Heading>
      )}
      <Section>{bodyText}</Section>
    </Box>
  );
};
